import styled from 'styled-components';

const BaseLayout = styled.div`
    display: grid;
    height: 100vh;
    width: 100%;
    grid-template-columns: [page-start sidebar-start] 300px [sidebar-end] 250px auto 250px [page-end];
    grid-template-rows: [page-top header-top] 50px [header-bottom] 300px auto [timeline-top] 150px [timeline-bottom page-bottom];
`;

export default BaseLayout;
